export const gray = {
    gray0: '#fcfcfc',
    gray100: '#f9f9f9',
    gray200: '#f5f5f5',
    gray300: '#ececec',
    gray400: '#e4e4e4',
    gray500: '#dddddd',
    gray600: '#d5d5d5',
    gray700: '#cacaca',
    gray800: '#b7b7b7',
    gray900: '#888888',
    gray1000: '#7d7d7d',
    gray1100: '#5f5f5f',
    gray1200: '#1f1f1f',
    grayAccentContrast: '#ffffff',
    grayAccentSurface: '#e6e6e6',
};

export const grayAlpha = {
    gray0: 'rgba(0, 0, 0, 0)',
    gray100: 'rgba(0, 0, 0, 0.01)',
    gray200: 'rgba(0, 0, 0, 0.03)',
    gray300: 'rgba(0, 0, 0, 0.06)',
    gray400: 'rgba(0, 0, 0, 0.09)',
    gray500: 'rgba(0, 0, 0, 0.12)',
    gray600: 'rgba(0, 0, 0, 0.15)',
    gray700: 'rgba(0, 0, 0, 0.2)',
    gray800: 'rgba(0, 0, 0, 0.27)',
    gray900: 'rgba(0, 0, 0, 0.46)',
    gray1000: 'rgba(0, 0, 0, 0.51)',
    gray1100: 'rgba(0, 0, 0, 0.62)',
    gray1200: 'rgba(0, 0, 0, 0.88)',
    grayAccentContrast: '#ffffff',
    grayAccentSurface: 'rgba(224, 224, 224, 0.8)',
};

export const grayDark = {
    gray0: '#000000',
    gray100: '#111111',
    gray200: '#191919',
    gray300: '#232323',
    gray400: '#2a2a2a',
    gray500: '#313131',
    gray600: '#3a3a3a',
    gray700: '#484848',
    gray800: '#616161',
    gray900: '#6f6f6f',
    gray1000: '#7c7c7c',
    gray1100: '#b4b4b4',
    gray1200: '#eeeeee',
    // TODO contrast', surface
};

export const grayDarkAlpha = {
    gray0: 'rgba(255, 255, 255, 0.01)',
    gray100: 'rgba(255, 255, 255, 0.02)',
    gray200: 'rgba(255, 255, 255, 0.04)',
    gray300: 'rgba(255, 255, 255, 0.07)',
    gray400: 'rgba(255, 255, 255, 0.11)',
    gray500: 'rgba(255, 255, 255, 0.13)',
    gray600: 'rgba(255, 255, 255, 0.17)',
    gray700: 'rgba(255, 255, 255, 0.23)',
    gray800: 'rgba(255, 255, 255, 0.34)',
    gray900: 'rgba(255, 255, 255, 0.4)',
    gray1000: 'rgba(255, 255, 255, 0.45)',
    gray1100: 'rgba(255, 255, 255, 0.69)',
    gray1200: 'rgba(255, 255, 255, 0.93)',
    // TODO contrast', surface
};
